
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.47 16.47a.75.75 0 111.06 1.06l-5.5 5.5a.75.75 0 01-1.06 0l-2.5-2.5a.75.75 0 111.06-1.06l1.97 1.97 4.97-4.97z","fill":"#2ECC71"}}),_c('path',{attrs:{"d":"M15.707 5.913c1.68 0 3.262.655 4.452 1.846A6.25 6.25 0 0122 12.212c-.002 2.681-1.693 4.974-4.062 5.875a6.27 6.27 0 00-.495-1.064 5.129 5.129 0 003.387-4.812 5.088 5.088 0 00-1.5-3.623 5.087 5.087 0 00-3.621-1.504 5.13 5.13 0 00-1.468.213.586.586 0 01-.335-1.122 6.33 6.33 0 011.802-.263zm-7.43 0a6.268 6.268 0 014.442 1.82l3.463 3.463c.404.404.625.94.624 1.511a2.117 2.117 0 01-.63 1.51 2.136 2.136 0 01-3.006-.01l-3.172-3.172a.957.957 0 00-1.63.672.95.95 0 00.279.678l3.089 3.09a4.718 4.718 0 00-1.375.282l-2.543-2.543a2.112 2.112 0 01-.622-1.51c.002-.57.226-1.106.632-1.506a2.131 2.131 0 012.998.008l3.173 3.173a.96.96 0 001.635-.674.95.95 0 00-.28-.68l-3.46-3.46a5.086 5.086 0 00-3.613-1.48 5.085 5.085 0 00-3.65 1.536 5.09 5.09 0 00-1.458 3.688c.043 2.16 1.453 4.006 3.387 4.711-.197.336-.364.69-.497 1.063-2.325-.894-4.01-3.133-4.061-5.75A6.253 6.253 0 013.792 7.8a6.246 6.246 0 014.486-1.887z","fill":"currentColor"}})])
          )
        }
      }
    